import type { LinksDropdownLinkComponent } from '@twisto/api-cms'
import { useIsMobile } from '@twisto/hooks'

import { DropdownLinkHolder } from '../dropdown-link-holder'
import { LinkList } from '../link-list'

import * as styles from './dropdown-link.styles'

type DropdownLinkProps = {
  isOpen?: boolean
}

export const DropdownLink = ({
  content,
  inline,
  link,
}: LinksDropdownLinkComponent & DropdownLinkProps) => {
  const isMobile = useIsMobile()

  if (!link) {
    return null
  }

  const Dropdown = () => (
    <div className="dropdown" css={styles.dropdown}>
      <div css={[styles.content, !isMobile && inline && styles.inlineContent]}>
        {content?.map((list) => (
          <LinkList key={list.id} listStyles={styles.list} {...list} />
        ))}
      </div>
    </div>
  )

  return (
    <DropdownLinkHolder link={link}>
      {content && content.length ? <Dropdown /> : null}
    </DropdownLinkHolder>
  )
}
